import React, { Component } from 'react';
import { Box } from 'grommet/components/Box';
import { Anchor } from 'grommet/components/Anchor';
import { Image } from 'grommet/components/Image';
import logo from '../Assets/logoamexline.svg';

class Footer extends Component {


    render() {
        var date = new Date();
        var year = date.getFullYear();


        return (
            <Box id='footer' direction='row'>
                <Box style={{ padding: '17px 20px', margin: '0 auto', width: '1240px' }}>
                    <Box className='footer'>

                        <Box style={{ verticalAlign: 'middle', width: '50%', float: 'left' }} direction="column" className='footer-left'>
                            <div style={{ alignSelf: 'start', textAlign: "left" }}>
                                <Image id='logofooter' src={logo} alt="logo" tabIndex="0" />
                            </div>
                            <div id='privacy' direction='row' style={{ width: '195px', textDecoration: 'none' }}>
                                <Anchor className='link' href='https://www.americanexpress.com/it/terms-and-conditions.html?inav=it_legalfooter_terms' target='_blank'>Termini e Condizioni</Anchor>
                                <span>|</span>
                                <Anchor className='link' href='https://www.americanexpress.com/it/legal/dichiarazione-privacy-online.html' target='_blank'>Privacy</Anchor>
                            </div>
                        </Box>


                        <Box className='footer-right'>
                            <Box id='copyright' style={{ textAlign: 'right', marginTop: '27px' }}>
                                Copyright © {year} American Express Company
                        </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default Footer;
